import { Box, CircularProgress } from '@mui/material'
import {
  ModalActionButton,
  ModalActionButtonsContainer,
} from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'

export default function FormActionButtons({
  onCancel,
  onSave,
  saving,
  isValid,
  isEdit,
  isDisabled,
  fullWidthActions = false,
}) {
  return (
    <ModalActionButtonsContainer
      style={
        fullWidthActions
          ? { flexDirection: 'column', width: '100%', gap: 12 }
          : undefined
      }
    >
      <ModalActionButton onClick={onCancel} style={fullWidthActions ? { width: '100%' } : undefined}>
        Cancel
      </ModalActionButton>
      <ModalActionButton
        success={isValid || !saving}
        onClick={() => {
          if (isValid || !saving) {
            onSave()
          }
        }}
        disabled={isDisabled}
        style={fullWidthActions ? { width: '100%' } : undefined}
      >
        <Box sx={{ display: 'flex' }}>
          {saving ? (
            <CircularProgress size={24} sx={{ color: '#415dfc' }} />
          ) : (
            <>{isEdit ? 'Save' : 'Create'}</>
          )}
        </Box>
      </ModalActionButton>
    </ModalActionButtonsContainer>
  )
}
